import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} width="16" height="14" viewBox="0.081 0.138 15.684 13.723">
    <path
      paintOrder="stroke fill markers"
      fillRule="evenodd"
      d="M7.923.138c2.165 0 4.126.878 5.545 2.298L15.765.138V6.02H9.884l2.198-2.198a5.882 5.882 0 1 0-8.049 8.57l-1.297 1.47A7.842 7.842 0 0 1 7.923.139z"
    />
  </SvgIcon>
);

export default Icon;
